<template>
  <egg-label-list
    title="insurer.costContainment"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconPurple', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleRightBig', imgFormat: 'svg', position: 'right:0;' }"
    :eggBackgroundObj="{ componentName: 'shared', imgName: 'purpleegg', imgFormat: 'svg' }"
    labelColor="#4E4E4E"
    :eggIconLabelList="insurerStore.eggDescList"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useInsurerStore } from "@/stores/insurer";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const insurerStore = useInsurerStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>